import { ThemeContext } from '../../../constants/themes';
import Button from '../../../components/atoms/Button';
import Type from '../../../components/atoms/Type';
import './index.css';

const ClaimedRecordingRequestRow = ({ recording_id, name, bounty, type, onUploadClick }) => {
   const onClick = () => {
      onUploadClick(recording_id);
   }

   return (
      <ThemeContext.Consumer>
         {themeContext => (
            <div className="otherrecordingrow-div">
               <div className="otherrecordingrow-name">
                  <a href={type === 'labels' ? undefined : `https://${name}`} target="_blank"><Type style={{textDecorationColor: themeContext.theme.text, margin: 0, color: type === 'labels' ? themeContext.theme.subtle : themeContext.theme.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{name}</Type></a>
               </div>
               <div className="otherrecordingrow-bounty">
                  <Type style={{margin: 0, color: type === 'labels' ? themeContext.theme.subtle : themeContext.theme.text, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{type === 'labels' ? bounty : `$${parseFloat(bounty).toFixed(2)}`}</Type>
               </div>
               {type === 'labels' ?
                  <div className="otherrecordingrow-upload">
                     
                  </div>
                  :
                  <div className="otherrecordingrow-upload">
                     <Button value='Upload recording' onClick={onClick} />
                  </div>
               }
            </div>
         )}
      </ThemeContext.Consumer>
   )
}

export default ClaimedRecordingRequestRow;